export default __webpack_public_path__ + "static/bodySectionBg-3cf095d010b9888be2d6bf70812d69aa.png";